var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg28(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "161.02mm",
    height: "139.85mm",
    viewBox: "0 0 161.02 139.85",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17429"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17439"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17449"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17459"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17491"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m459.75 147.75h59.25v58.5h-59.25z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17501"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17513"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m141.75 145.5h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17523"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17607"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m290.94 219.47 17.74-51.98-51.97-17.74-17.74 51.97z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17617"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17627"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m313.5 150h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17637"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.5851 -83.272)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 -34.213 256.39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m107.14 94.286h456.43v396.43h-456.43z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.88 265.87c0 27.76 22.66 50.25 50.62 50.25s50.63-22.49 50.63-50.25c0-27.75-22.67-50.25-50.63-50.25s-50.62 22.5-50.62 50.25z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.88 265.87c0 27.76 22.66 50.25 50.62 50.25s50.63-22.49 50.63-50.25c0-27.75-22.67-50.25-50.63-50.25s-50.62 22.5-50.62 50.25z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.38 193.12h17.25v44.25h-17.25z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.38 193.12h17.25v44.25h-17.25z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.88 191.62h17.25v44.25h-17.25z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.88 191.62h17.25v44.25h-17.25z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.38 276c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.38 276c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.63 276c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.63 276c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.23 274.11c0-1.08-0.87-1.95-1.94-1.95-1.08 0-1.95 0.87-1.95 1.95 0 1.07 0.87 1.95 1.95 1.95 1.07 0 1.94-0.88 1.94-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.17 274.31c0-1.08-0.87-1.95-1.95-1.95s-1.95 0.87-1.95 1.95c0 1.07 0.87 1.95 1.95 1.95s1.95-0.88 1.95-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.38 307.87 25.5 49.5 25.5-49.5z",
    fill: "#4472c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m288.38 307.87 25.5 49.5 25.5-49.5z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m277.1 246.58-11.87-7.69c-6.56-4.25-13.96-4.46-16.55-0.47-2.58 3.98 0.65 10.65 7.2 14.9l11.87 7.69z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m277.1 246.58-11.87-7.69c-6.56-4.25-13.96-4.46-16.55-0.47-2.58 3.98 0.65 10.65 7.2 14.9l11.87 7.69z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m351.51 271.64 16.43 10.59c9.08 5.85 19.02 6.58 22.2 1.64 3.19-4.95-1.58-13.7-10.66-19.54l-16.43-10.6z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m351.51 271.64 16.43 10.59c9.08 5.85 19.02 6.58 22.2 1.64 3.19-4.95-1.58-13.7-10.66-19.54l-16.43-10.6z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m338.63 254.25c0-6.01-9.91-10.88-22.13-10.88s-22.12 4.87-22.12 10.88h5.43c0-3 7.47-5.44 16.69-5.44s16.69 2.44 16.69 5.44z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.63 254.25c0-6.01-9.91-10.88-22.13-10.88s-22.12 4.87-22.12 10.88h5.43c0-3 7.47-5.44 16.69-5.44s16.69 2.44 16.69 5.44z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.38 146.62 19.49 78h362.26l19.5-78z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.38 146.62 19.49 78h362.26l19.5-78z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17491)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.82292 -1.88e-7 -7.54e-7 .8125 459.75 147.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.959 17.616c-1.8 1.425-3.15 2.7-3.975 4.8-0.15 0.3-0.225 0.675-0.3 0.975v0.075c-0.15 0.525-0.6 0.9-1.125 0.9h-46.2c-0.525 0-0.975-0.375-1.125-0.9-0.075-0.375-0.15-0.675-0.3-1.05-0.825-2.1-2.25-3.375-4.05-4.875v-3h57.075v3.075zm-1.5-1.5h-54.075v0.75c1.725 1.275 3.15 3.075 3.975 5.025 0.15 0.3 0.225 0.6 0.3 0.975h45.6c0.075-0.375 0.15-0.675 0.3-0.975 0.825-1.95 2.175-3.675 3.975-5.025v-0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.459 30.366c-1.425 1.35-2.475 3.075-3 4.95-1.8 7.35-6.975 11.625-14.25 13.125-0.75 0.15-1.5 0.3-2.325 0.375 0 0.375-0.15 0.75-0.225 1.125-0.6 1.425-1.95 2.475-3.525 2.55v3.375h3c0.45 0 0.75 0.3 0.75 0.75s-0.3 0.75-0.75 0.75h-7.5c-0.45 0-0.75-0.3-0.75-0.75s0.3-0.75 0.75-0.75h3v-3.375c-1.5-0.15-2.85-1.125-3.45-2.55-0.15-0.375-0.225-0.75-0.225-1.125-0.75-0.075-1.5-0.225-2.325-0.375-7.275-1.5-12.45-5.775-14.25-13.125-0.525-1.875-1.575-3.6-3-4.95v-3h48zm-26.85 19.05c0.45 0.975 1.425 1.65 2.55 1.65h0.525c1.125 0 2.1-0.6 2.55-1.65 0.075-0.15 0.075-0.375 0.15-0.525h-5.85c0 0.15 0 0.375 0.075 0.525zm25.35-20.55h-45v0.9c1.425 1.5 2.475 3.3 2.925 5.25 1.575 6.45 6 10.5 13.125 12 1.5 0.3 3 0.45 4.5 0.45h3.9c1.5 0 3-0.15 4.5-0.45 7.125-1.5 11.55-5.55 13.125-12.075 0.525-1.95 1.5-3.75 2.925-5.175z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17513)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.75,145.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.875 38.474c-0.105 0-0.211 5e-3 -0.318 0.014-1.14 0.093-2.174 0.704-2.805 1.657l-3.9753 5.846c-0.5801 0.843-0.7828 1.89-0.5595 2.889 0.2284 1.025 0.8681 1.912 1.7693 2.452 16.984 10.044 38.088 10.044 55.072 0 0.901-0.54 1.541-1.427 1.77-2.452 0.223-1 0.02-2.047-0.561-2.891l-3.976-5.85c-1.122-1.705-3.414-2.178-5.12-1.056-0.219 0.144-0.421 0.311-0.605 0.497l-3.675 3.675c-0.737 0.674-1.146 1.634-1.121 2.631v3.284c-9.261 3.012-19.238 3.012-28.5 0v-3.283c-5e-3 -0.99-0.405-1.937-1.111-2.631l-3.675-3.675c-0.68-0.713-1.624-1.113-2.609-1.107zm21.651 18.892c-9.418 0.01-18.665-2.52-26.767-7.322-0.5481-0.325-0.9365-0.863-1.0725-1.485-0.1337-0.597-0.0128-1.222 0.3337-1.725l3.9748-5.854c0.379-0.575 1.002-0.943 1.688-1 0.643-0.064 1.281 0.173 1.725 0.644l3.69 3.691c0.427 0.412 0.672 0.977 0.68 1.57v4.369l0.513 0.171c9.885 3.336 20.591 3.336 30.476 0l0.512-0.171v-4.367c-0.019-0.581 0.216-1.143 0.645-1.536l3.71-3.71c0.845-0.871 2.237-0.892 3.107-0.046 0.119 0.115 0.224 0.243 0.314 0.381l3.975 5.858c0.347 0.504 0.468 1.129 0.335 1.725-0.136 0.624-0.525 1.163-1.075 1.487-8.101 4.801-17.347 7.33-26.764 7.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.778 14.6h-46.5v13.95c-0.02 1.798 0.681 3.529 1.945 4.807l8.553 8.559v3.45c0 1.657 1.343 3 3 3h0.608c1.657 0 3-1.343 3-3v-2.258h12.141v2.258c0 1.657 1.343 3 3 3h0.75c1.657 0 3-1.343 3-3v-3.45l8.559-8.479c1.258-1.283 1.958-3.011 1.95-4.808zm-45 1.5h43.5v12.525c0.01 1.398-0.53 2.744-1.505 3.746l-8.996 8.924v4.071c0 0.828-0.671 1.5-1.5 1.5h-0.75c-0.828 0-1.5-0.672-1.5-1.5v-3.758h-15.143v3.758c0 0.828-0.672 1.5-1.5 1.5h-0.608c-0.829 0-1.5-0.672-1.5-1.5v-4.069l-8.995-9c-0.989-0.994-1.532-2.347-1.505-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.527 34.856m1.5 1.5h-3v-3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.527 28.854m1.5 1.5h-3v-3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.527 22.852m1.5 1.5h-3v-3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.527 34.856m1.5 1.5h-3v-3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.527 28.854m1.5 1.5h-3v-3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.527 22.852m1.5 1.5h-3v-3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.526 34.856m1.5 1.5h-3v-3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.526 28.854m1.5 1.5h-3v-3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.526 22.852m1.5 1.5h-3v-3h3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m315.02 427.97c-2.76 15.45 11.44 29.68 31.72 31.79 8.21 0.85 16.57-0.43 23.72-3.62 7.58 10.89 25.29 15.03 39.56 9.25 2.5-1.02 4.79-2.3 6.8-3.81 5.9 9.03 20.28 12.69 32.12 8.19 3.27-1.25 6.13-3.05 8.35-5.27 9.52 8.54 26.33 9.59 37.56 2.36 4.72-3.04 7.9-7.24 8.99-11.87 15.59-3.24 24.79-15.53 20.55-27.44-0.36-1-0.81-1.98-1.34-2.93 12.5-12.41 9.44-30.2-6.84-39.73-5.07-2.97-11.05-4.89-17.38-5.58-0.14-13.35-14.46-24.08-31.99-23.98-5.86 0.04-11.59 1.31-16.55 3.67-5.93-14.97-26.61-23.43-46.19-18.9-8.21 1.9-15.3 5.92-20.06 11.37-20.05-9.22-46.07-4.26-58.12 11.08-0.15 0.19-0.3 0.38-0.45 0.58-13.12-1.17-25 5.97-26.54 15.94-0.82 5.32 1.48 10.64 6.29 14.55-11.36 5.1-15.18 16.29-8.52 24.99 3.83 5.03 10.57 8.35 18.12 8.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.44 322.78c0-2.04-1.65-3.69-3.69-3.69s-3.69 1.65-3.69 3.69 1.65 3.69 3.69 3.69 3.69-1.65 3.69-3.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.84 327.34c0-4.08-3.31-7.38-7.38-7.38s-7.37 3.3-7.37 7.38c0 4.07 3.3 7.37 7.37 7.37s7.38-3.3 7.38-7.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383 338.23c0-6.11-4.95-11.07-11.06-11.07s-11.06 4.96-11.06 11.07 4.95 11.06 11.06 11.06 11.06-4.95 11.06-11.06z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17607)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.2464 .72186 -.72186 -.2464 308.68 167.49)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.329 61.398c0.787 0.89 0.98 2.686-1.075 4.822-0.872 0.979-2.098 1.572-3.408 1.646-0.581 0.028-1.15-0.171-1.588-0.554l-22.715-21.201-2.283-2.271-14.584-15.141c-0.567-0.581-1.114-1.181-1.641-1.8l-6.482-7.314-2.025-2.553-5.3848-7.0413c-0.2102-0.3768-0.1308-0.849 0.1913-1.1362l-1.7063-2.775c-0.1983-0.3129-0.1494-0.7221 0.117-0.9795 0.147-0.1485 0.3469-0.2327 0.5558-0.234 0.1506 7e-4 0.298 0.0438 0.4252 0.1245l2.748 1.725c0.1922-0.1906 0.4495-0.301 0.72-0.309 0.1435-0.0023 0.2844 0.0393 0.4035 0.1192l7.0973 5.3373 2.566 2.012 7.314 6.483c0.619 0.526 1.219 1.073 1.8 1.64l15.142 14.585 2.273 2.281 17.969 18.802 0.191 0.2 0.592-0.592c0.586-0.585 0.586-1.535 0-2.121l-13.38-13.38c-0.297-0.288-0.304-0.763-0.015-1.06 0.288-0.297 0.763-0.304 1.06-0.015 6e-3 6e-3 0.013 0.012 0.018 0.018l13.381 13.38c1.171 1.171 1.171 3.07 0 4.242l-0.616 0.616 0.838 0.876zm-57.926-53.141-1.5285 1.5293 4.827 6.313 0.437 0.551 3.178-3.177-0.525-0.41zm17.924 14.816c-0.554-0.541-1.134-1.07-1.748-1.592l-7.28-6.45-0.795-0.624-3.428 3.428 0.625 0.787 6.475 7.307c0.503 0.591 1.032 1.171 1.575 1.732l14.566 15.116 0.537 0.533 5.133-5.133-0.512-0.514zm17.4 16.85-0.681-0.684-5.129 5.129 0.667 0.663 22.696 21.185 0.014 0.013 0.019 0.018c0.162 0.09 0.347 0.132 0.532 0.119 0.897-0.087 1.728-0.511 2.325-1.187 1.238-1.286 1.41-2.332 1.045-2.775l-1.475-1.543-2.066-2.161z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17627)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(313.5,150)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.384 39.366h30v1.5h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 45.366h14.25v1.5h-14.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 33.366h30v1.5h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 27.366h30v1.5h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 21.366h30v1.5h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 15.366h30v1.5h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.884 66.366v-60h45v43.81l-16.19 16.19zm29.263-2.573 13.164-13.164c3e-3 -3e-3 3e-3 -8e-3 0-0.011-2e-3 -1e-3 -4e-3 -2e-3 -6e-3 -2e-3h-13.171v13.171c0 5e-3 3e-3 8e-3 8e-3 8e-3 2e-3 0 3e-3 -1e-3 5e-3 -2e-3zm-27.763-55.927v57h26.25v-15.75h15.75v-41.25z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m171.38 121.51v24.36",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 8,
    strokeWidth: 5.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.38 121.51v24.36",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 8,
    strokeWidth: 5.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg28);
export default __webpack_public_path__ + "static/media/28.e9b8764ed3966ff47f130c17ae0fdd8f.svg";
export { ForwardRef as ReactComponent };